import * as React from 'react';

const H2ChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="h2-chunky_svg__eds-icon--h2-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="h2-chunky_svg__eds-icon--h2-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 12H5V6H3v14h2v-6h7v6h2V6h-2z"
        />
        <path
            id="h2-chunky_svg__eds-icon--h2-chunky_number"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.7 10c0-1 .7-1.1 1.6-1.7 1.3-.8 1.5-1.6 1.5-2.3 0-1.2-.8-2-2.2-2-1.2 0-2 .5-2.5 1.4l1 .7c.4-.6.9-1 1.5-1s.9.3.9.8c-.1.8-.5 1.1-1.5 1.7-1.8 1.1-2 2.1-2 3v.4h5v-1h-3.3z"
        />
    </svg>
);

H2ChunkySvg.displayName = 'H2ChunkySvg';
export default H2ChunkySvg;
